import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
    Card, Divider, Header, Icon, Loader, Button,
    Segment, Modal, Dimmer, Image, Grid,
} from 'semantic-ui-react';

import {getPlaceOrderInProgress} from "../../views/Orders/reducer";
import {Link} from "react-router-dom";

import './styles.css';
import {getCountries, isCountriesFetching} from "../AddressCard/reducer";
import {
    fetchCounties,
} from "../AddressCard/actions";
import OrderCardHeader from "./OrderCardHeader";
import {receiveOrderData} from "../../views/Orders/actions";
import ModalPayment from "../ModalPayment/ModalPayment";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import {getAuthFetching} from "../UserLogin/reducer";
import ModalImageGallery from "../ModalImageGallery";
import {getTypeExhibition} from "../../views/Home/reducer";

export default function MiniOrderCard(props) {

    const { order, circular, header, actionButtons, dispatch, token, userData, userLocation, mixpanel , isLoggedIn } = props;
    const { billing, id, status} =  order;

    const getLoading = useSelector((state) => getPlaceOrderInProgress(state.orders));
    const getLoadingCountries = useSelector((state) => isCountriesFetching(state.address));
    const isFetchingUserData = useSelector((state) => getAuthFetching(state.userLogin));
    const countries = useSelector((state) => getCountries(state.address));
    const language = useSelector(getLanguage);
    const languageString = language[0] + language[1];

    const [paymentOpen, setPaymentOpen] = React.useState(false);

    const country = countries && countries.countries ? countries.countries[billing.country] ?? {} : {};
    const countryStates = country && country.states
        ? country.states.filter( item => String(item.code) === String(billing.state)) : [];

    useEffect(() => {
        if (typeof country.iso === 'undefined' && !getLoadingCountries) {
            //console.warn('Mini order card has queried countries ...');
            dispatch(fetchCounties());
        }
        // защита от зависания страницы в лоадинге
        dispatch(receiveOrderData([]));
    }, []);

    const orderCountry = country.iso ? country.emoji + ' ' + country['country_' + languageString] : '';
    const orderState = countryStates.length ? countryStates[0]['name_' + languageString] : '';
    const needsPayment = status === 'pending' || status === 'on-hold';

    const [modalActive, setModalActive] = useState(false);

    const OrderImage = () => (
       <>

            <Image src = { order.qrcode ?? "https://react.semantic-ui.com/images/wireframe/square-image.png" }
                   size="large"
                   circular= { false }
                   className="order-image" onClick={() => order.qrcode ? setModalActive(true) : '' }
            />
           <ModalImageGallery
               open={modalActive}
               handleOpen={() => setModalActive(true)}
               handleClose={() => setModalActive(false)}
               images={[
                   {
                       original: order.qrcode,
                       thumbnail: order.qrcode,
                   }
               ]}
               showAsGallery={false}
               index={0}
           />
       </>
    );


    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] : key;
    };

    const billing_suffix_lang = languageString === 'ru' ? 'uc' : languageString;

    // console.log('mini order card', isFetchingUserData, getLoadingCountries, getLoading)

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibitions = {
        asia: {
            color: '#B10000'
        },
        gras: {
            color: '#037C00'
        }
    }
    return (
        <div>
            <Card centered color="blue" raised className="card-order">
                <OrderCardHeader order={order} {...props}/>
                <div>
                    <p className={'order-header-name-services'}>
                        {
                            languageString === "ru" ?
                                Array.isArray(order.line_items) && order.line_items.length > 0
                                    ? order.line_items[0].name
                                    : order.line_items.name
                                :
                                Array.isArray(order.line_items) && order.line_items.length > 0
                                    ? order.line_items[0].name_en
                                    : order.line_items.name_en
                        }
                    </p>
                </div>
                <Card.Content className="card-order-content">
                    {(+order?.total === 0) ? <Grid className='grid-order-first-second-col'>
                        <Grid.Column className="order-mini-card-header-first-col">
                            <div style={{textAlign: "left"}}>
                                <OrderImage/>
                            </div>
                        </Grid.Column>
                        <Grid.Column className="order-mini-card-header-second-col">
                            <Card.Header className="order-header-fio-col">
                                <div style={{fontSize: '16px', fontWeight: 'bold'}}>
                                    <div>{billing['last_name_' + billing_suffix_lang] + ' ' + billing['first_name_' + billing_suffix_lang]}</div>
                                    <div>{billing['company_' + billing_suffix_lang]}</div>
                                    <div> {billing['company_job_title']}</div>
                                    <div> {billing['company_scope_' + billing_suffix_lang]}</div>
                                </div>
                            </Card.Header>
                        </Grid.Column>
                    </Grid> : <div style={{textAlign: 'center', fontSize: '16px', fontWeight: 'bold', marginBottom: '10px'}}>
                        <div>{billing['last_name_' + billing_suffix_lang] + ' ' + billing['first_name_' + billing_suffix_lang]}</div>
                        <div>{billing['company_' + billing_suffix_lang]}</div>
                        <div> {billing['company_job_title']}</div>
                        <div> {billing['company_scope_' + billing_suffix_lang]}</div>
                    </div> }
                    <div style={{textAlign: "left"}}>
                        <Segment className="order-mini-card-contacts">
                            <a className="order-mini-card-phone" href={'tel:' + billing.phone}>
                                <Icon name="call" style={{
                                    color: dataExhibitions[typeExhibition].color,
                                    width: '13px',
                                    height: '13px',
                                    transform: 'scaleX(-1)'
                                }}/>
                                {billing.phone}
                            </a>
                            <a className="order-mini-card-mail" href={'mailto:' + billing.email}>
                                <Icon name="mail" style={{
                                    color: dataExhibitions[typeExhibition].color,
                                    width: '13px',
                                    height: '13px'
                                }}/>
                                {billing.email}
                            </a>
                        </Segment>
                        <div className="order-mini-card-country" size="small"
                             dangerouslySetInnerHTML={{__html: `${orderCountry}, ${orderState}`}}/>
                    </div>

                    <div className="order-card-action-buttons">
                        {actionButtons
                            ?
                            <div>
                                <Button.Group className="mini-order-action-buttons" fluid>
                                    {needsPayment ?
                                        <>
                                            <Button
                                                className={`mini-order-action-button-pay ${typeExhibition}`}
                                                onClick={() => setPaymentOpen(true)}
                                                compact
                                            >
                                                {t('payment')}
                                            </Button>
                                            <ModalPayment
                                                open={paymentOpen}
                                                headerIcon="payment"
                                                headerText={t("payWndHeader")}
                                                handleOpen={() => setPaymentOpen(true)}
                                                handleClose={() => setPaymentOpen(false)}
                                                order={order}
                                            />
                                        </>
                                        : null}
                                </Button.Group>
                            </div>
                            : <Link to={'/orders/' + id}>
                                <Button fluid color="orange">
                                    {t('details')}
                                </Button>
                            </Link>}
                    </div>
                </Card.Content>
            </Card>

        </div>
    );
}